/**
 *
 * Asynchronously loads the component for Ben012
 * Author: Lanvt
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
